import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { CheckboxGroup } from "react-spark";

import {
  checkboxAndRadioOptionsPropTypes,
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";
import { titleCase } from "../../../helpers/filters";

class URCCheckbox extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { name } = this.props;

    this.props.context.registerFormElement({
      value: this.props.value,
      name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    const { name } = this.props;

    if (!this.props.context.isFormElementRegistered(name)) {
      this.props.context.registerFormElement({
        value: this.value,
        name,
        valid: this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  _cleanOptions() {
    const { options } = this.props;
    return options.map(o => {
      const option = Object.assign({}, o);

      if (_.isNil(option.label)) {
        option.label = titleCase(o.value);
      }

      return option;
    });
  }

  render() {
    const {
      className,
      context,
      defaultValue,
      errorMessage,
      label,
      handleChange,
      name,
      value,
      disabled
    } = this.props;

    const processedOptions = this._cleanOptions();

    const resolvedClassName = className.replace(
      "form-control",
      "form-check-input"
    );

    return (
      <CheckboxGroup
        className={resolvedClassName}
        checkboxes={processedOptions}
        defaultValue={defaultValue}
        error={errorMessage}
        id={name}
        label={label}
        name={name}
        disabled={disabled}
        onChange={event => handleChange(event, context)}
        value={value}
      />
    );
  }
}

URCCheckbox.defaultProps = {
  ...withValidationOutputDefaultProps,
  ...sharedFormInputDefaultProps,
  label: "",
  value: []
};

URCCheckbox.propTypes = {
  ...checkboxAndRadioOptionsPropTypes,
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  label: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string)
};

export default withValidation(URCCheckbox, { type: "checkbox" });
